import { format, parseISO } from 'date-fns'
import { es } from 'date-fns/locale/es'

/** "1 oct al 31 dic 2026" a partir de "AAAA-MM-DD" (informativo, §8.7). */
export function formatearPeriodo(desde: string | null, hasta: string | null): string {
  const d = desde ? parseISO(desde) : null
  const h = hasta ? parseISO(hasta) : null
  if (d && h) {
    const mismoAnio = d.getFullYear() === h.getFullYear()
    const inicio = format(d, mismoAnio ? 'd MMM' : 'd MMM yyyy', { locale: es })
    return `${inicio} al ${format(h, 'd MMM yyyy', { locale: es })}`
  }
  if (d) return `Desde el ${format(d, 'd MMM yyyy', { locale: es })}`
  if (h) return `Hasta el ${format(h, 'd MMM yyyy', { locale: es })}`
  return 'Sin período'
}

/** "3 oct" para las personas con acceso. */
export function formatearDiaCorto(iso: string): string {
  return format(new Date(iso), 'd MMM', { locale: es })
}
